<script setup></script>

<template>
  <img
    src="/images/ashley-friel-gsc-logo.jpg"
    alt="Georgian Shores Construction Logo"
    width="200"
    height="200"
    class="rounded-4"
  />

  <p class="section-text mt-4">
    <strong class="">To Whom it May Concern,</strong>
  </p>

  <p class="section-text">
    I am writing to provide a reference for Ashley Friel, who worked as a construction laborer at Georgian Shores
    Construction. Throughout her tenure with us, Ashley has demonstrated exceptional dedication, skill, and
    professionalism in her role.
  </p>

  <p class="section-text">
    As a construction labourer, Ashley was involved in a variety of projects that required a broad skill set and a
    strong work ethic. Her responsibilities included:
  </p>

  <!-- List items -->
  <div class="d-flex align-items-center gap-3">
    <i class="bi bi-arrow-right text-primary"></i>
    <span class="">
      Assisting skilled tradespeople such as carpenters, electricians, and plumbers in the completion of their tasks.
    </span>
  </div>
  <div class="d-flex align-items-center gap-3 mt-1">
    <i class="bi bi-arrow-right text-primary"></i>
    <span class=""> Operating and maintaining construction equipment and machinery with precision and care. </span>
  </div>
  <div class="d-flex align-items-center gap-3 mt-1">
    <i class="bi bi-arrow-right text-primary"></i>
    <span class="">
      Handling the physical demands of construction work, including heavy lifting, manual labor, and extended hours.
    </span>
  </div>
  <div class="d-flex align-items-center gap-3 mt-1">
    <i class="bi bi-arrow-right text-primary"></i>
    <span class=""> Ensuring the safety of the worksite by adhering to all safety protocols and regulations. </span>
  </div>
  <div class="d-flex align-items-center gap-3 mt-1">
    <i class="bi bi-arrow-right text-primary"></i>
    <span class=""> Participating in the cleanup and organization of the worksite at the end of each day. </span>
  </div>
  <div class="d-flex align-items-center gap-3 mt-1">
    <i class="bi bi-arrow-right text-primary"></i>
    <span class=""> Bringing Safety Awareness to all those onsite. </span>
  </div>

  <p class="section-text">
    One of the standout qualities of Ashley is her incredible work ethic. She consistently arrived at the worksite on
    time, ready to contribute to the day's tasks with enthusiasm and a positive attitude. Her reliability and
    punctuality made her a valuable member of our team, and I have always been able to count on her to complete all
    assignments efficiently and effectively.
  </p>

  <p class="section-text">
    In addition to her strong work ethic, Ashley possesses excellent problem-solving skills. Construction work often
    presents unexpected challenges, and Ashley has repeatedly shown her ability to think on their feet and find
    practical solutions. Whether it was troubleshooting equipment issues or finding ways to improve worksite efficiency,
    her innovative approach has greatly benefited our projects.
  </p>

  <p class="section-text">
    Furthermore, Ashley has demonstrated strong teamwork and communication skills. She works well with others and has
    built positive relationships with her colleagues. Her ability to communicate clearly and collaborate effectively has
    contributed to a cohesive and productive work environment. Ashley is not only a team player but also takes
    initiative when needed, often stepping up to lead tasks and guiding less experienced workers.
  </p>

  <p class="section-text">
    Safety is paramount in the construction industry, and Ashley has consistently prioritized the well- being of herself
    and her colleagues. She strictly adheres to all safety guidelines and protocols, ensuring that the worksite remains
    a secure place for everyone. Her commitment to safety has helped us maintain an excellent safety record and avoid
    accidents and injuries.
  </p>

  <p class="section-text">
    Ashley brings a positive attitude and strong character to the workplace. She is respectful, honest, and dependable,
    earning the trust and respect of her peers and supervisors alike. her dedication to her work and her integrity is
    evident in everything she does.
  </p>

  <p class="section-text">
    Overall, I highly recommend Ashley for any position. Her combination of skills, work ethic, problem- solving
    abilities, teamwork, and commitment to safety make her an asset to any team. I am confident that she will continue
    to excel and contribute positively to her future endeavors.
  </p>

  <p class="section-text">I am confident that Ashley will be a valuable addition to any team she joins. Sincerely,</p>

  <p class="section-text mb-0">
    <strong class="">Sincerely,</strong><br />
    Dale Schrobback<br />
    Vice President<br />
    Georgian Shores Construction Ltd.
  </p>
</template>

<style lang="scss" scoped></style>
